// @flow
import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import navigation from 'app/redux/actions/navigation';
import api from 'utils/API';
import styles from './CategoryArchive.styles.js';
import CategoryArchiveItem from 'app/components/CategoryArchiveItem';
import Pagination from 'app/components/Pagination';

type Props = {
  classes: any,
  page: number,
  categorySlug: string
};

type State = {
  currentPage?: ?number,
  perPage?: ?number,
  totalItems?: ?number,
  page?: ?number,
  list: array
};

class CategoryArchive extends React.Component<Props, State> {
  unmounted = false;
  
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      page: 1,
      currentPage: null,
      perPage: null,
      totalItems: null
    };
  }

  listFill = (count = 30) => {
    return new Array(30).concat().fill({});
  }

  fetchPage = () => {
    const url = `/category/${this.props.categorySlug}`;
    const page = this.props.page || 1;
    const count = this.props.count || 20;
    const filledList = this.listFill(count);
    const data = {page, count, id: this.props.categorySlug};

    this.setState({list: filledList});

    api.post(url, data)
    .then(response => {
      if (this.unmounted) {
        return;
      }

      const data = response.data;
      const category = data.list && data.list[0].category[0];

      // Set navigation data
      const navigationData = {
        category: {
          slug: category.slug,
          id: category.id,
        },
        meta: {
          title: data.g_title,
          description: data.g_description,
          canonicalUrl: data.g_canonical_url,
          nextUrl: data.g_next_url,
          prevUrl: data.g_prev_url,
          ogTitle: data.og_title,
          ogType: data.og_type,
          ogDescription: data.og_description,
          ogUrl: data.og_url,
          ogArticleSsection: data.og_article_section,
          ogSiteName: data.og_site_name,
          ogImage: data.og_image
        }
      };
      this.props.dispatch(navigation(navigationData));
      //
      
      this.setState({
        currentPage: data.pagination.page,
        perPage: data.pagination.count,
        totalItems: data.pagination.total,
        list: data.list || [],
      });
    }); 
  }

  componentDidMount() {
    this.fetchPage();
  }

  componentDidUpdate(prevProps, PrevState) {
    if (prevProps.page !== this.props.page || prevProps.categorySlug !== this.props.categorySlug) {
      this.fetchPage();
    }
  }

  componentWillUnmount() {
    this.props.dispatch(navigation({category: {}}));
    this.unmounted = true;
  }

  render() {
    const {classes} = this.props;
    return (
      <React.Fragment>
          {this.state.list && this.state.list.map((newsItem, index) => {
            const category = (newsItem.category && newsItem.category[0]) || {};
            return (
                <CategoryArchiveItem
                  colorful
                  key={newsItem.name || index}
                  data={newsItem}
                  category={category.id}
                  className={classes.card}
                />
            );
          })}
        <Pagination
          totalItems={this.state.totalItems}
          perPage={this.state.perPage}
          current={this.state.currentPage}
          urlTemplate={`/category/:category/page/:page`}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return ({
    pagination: state.pagination,
    navigation: state.navigation
})};

const Component = connect(mapStateToProps)(withStyles(styles)(CategoryArchive));
export {Component as CategoryArchive};
export default Component;